import { render } from "./managementPanel.vue?vue&type=template&id=1787211b&scoped=true"
import script from "./managementPanel.vue?vue&type=script&lang=js"
export * from "./managementPanel.vue?vue&type=script&lang=js"

import "./managementPanel.vue?vue&type=style&index=0&id=1787211b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1787211b"]])

export default __exports__